import { useEffect, useState } from "react";
import { GlobalNav } from "./components/GlobalNav";
import { SubNav } from "./components/SubNav";
import { Home } from "./pages/Home";
import { Ask } from "./pages/Ask";
import { Trends } from "./pages/Trends";
import { Settings } from "./pages/Settings";
import { getToken } from "./lib/api";

export type Route = "home" | "trends" | "ask" | "settings";

export default function App() {
  const [route, setRoute] = useState<Route>(() => readRouteFromHash());
  const [hasToken, setHasToken] = useState(() => getToken().length > 0);

  useEffect(() => {
    function onHash() {
      setRoute(readRouteFromHash());
    }
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);

  function navigate(to: Route): void {
    window.location.hash = to === "home" ? "" : to;
  }

  if (!hasToken) {
    return (
      <Settings
        firstRun
        onSaved={() => {
          setHasToken(true);
          navigate("home");
        }}
      />
    );
  }

  return (
    <div className="min-h-screen bg-canvas text-ink">
      <GlobalNav onNavigate={navigate} active={route} />
      <SubNav route={route} onNavigate={navigate} />
      <main className="pb-24">
        {route === "home" && <Home />}
        {route === "trends" && <Trends />}
        {route === "ask" && <Ask />}
        {route === "settings" && <Settings onSaved={() => undefined} />}
      </main>
    </div>
  );
}

function readRouteFromHash(): Route {
  const h = window.location.hash.replace("#", "").trim();
  if (h === "trends" || h === "ask" || h === "settings") return h;
  return "home";
}
